<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    // 组件刷新
    provide () {
      return {
        reload: this.reload
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    methods: {
      // 用于组件刷新
      reload () {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      }
    },
  }
</script>

<style lang="scss" type="text/scss">

  // 导入菜单栏样式
  @import './styles/scss/sidebar.scss';
  // 全局样式
  @import './styles/scss/common.scss';
  @import './styles/scss/reset.scss';
  @import './styles/scss/mixin.scss';

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue